import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    Input, DatePicker,
} from 'antd';
const FormItem = Form.Item;
import { actions, asyncGet } from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    handleReset= () => {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        values = formatFormData(values);
        console.log('=====searchValue', values);
        this.props.changeSearchValues(values);
        this.props.resetPagination();
        this.props.asyncGet();
    }
    sendCommend = () => {
        // 下发命令
        this.props.editShow();
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>第三方监测代码</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={6}>
                            <FormItem {...spans} label="URL">
                                {getFieldDecorator('url')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem {...spans} label="eId">
                                {getFieldDecorator('eid')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem {...spans} label="时间">
                                {getFieldDecorator('tm')(
                                    <DatePicker
                                        showTime
                                        format="YYYY-MM-DD"
                                        placeholder="选择时间"
                                    />)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({ current: 1 })),
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isSendCommend: true })),
});
export const formatFormData = values => {
    let result = {};
    Object.keys(values).forEach(key => {
        if (key == 'tm') {
            result[key] = moment(values[key].valueOf()).format("YYYY-MM-DD");
        } else if (typeof values[key] !== 'undefined') {
            if (values[key] instanceof moment) {
                result[key] = values[key].valueOf();
            } else {
                result[key] = values[key];
            }
        }
    });
    return result;
};

export default connect(null, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/monitor/thirdparty/search.js